import { gql } from '@apollo/client';

export const UpdateWorker = gql`
mutation UpdateWorker($updateWorkerId: ID!, $content: contentWorker!) {
  updateWorker(id: $updateWorkerId, content: $content) {
    status
  }
}
`;